import { Col, IconButton } from '@ksyos/design-system';
import { Fragment } from 'react';
import type { ServiceType } from '@common/enums';
import type { IContractSettingAddEditValidated } from '@common/validation/contractSetting';
import { useFormContext } from '@frontend/utils/hooks/useFormContext';
import type { OrganizationContractSettingsFormState } from './OrganizationContractSettings';
import { OrganizationContractSettingsContractPrice } from './OrganizationContractSettingsContractPrice';
import { OrganizationContractSettingsDate } from './OrganizationContractSettingsDate';

interface OrganizationContractSettingsRowProps {
    contractSettings: IContractSettingAddEditValidated[];
    isEditing: boolean;
    serviceType: ServiceType;
}
export function OrganizationContractSettingsRow(props: Readonly<OrganizationContractSettingsRowProps>) {
    const form = useFormContext<OrganizationContractSettingsFormState>();

    return (
        <Fragment>
            {props.contractSettings.map((contractSetting, index) => (
                <Fragment key={contractSetting.id ?? index}>
                    <Col span={4}>
                        <OrganizationContractSettingsDate
                            index={index}
                            isEditing={props.isEditing}
                            serviceType={props.serviceType}
                            variant="startDate"
                        />
                    </Col>
                    <Col span={4}>
                        <OrganizationContractSettingsDate
                            index={index}
                            isEditing={props.isEditing}
                            serviceType={props.serviceType}
                            variant="endDate"
                        />
                    </Col>
                    <Col span={3}>
                        <OrganizationContractSettingsContractPrice
                            index={index}
                            isEditing={props.isEditing}
                            serviceType={props.serviceType}
                        />
                    </Col>
                    <Col span={1}>
                        {props.isEditing && contractSetting.showDeleteButton && (
                            <IconButton
                                icon="delete"
                                onClick={() => form.removeArrayItem(props.serviceType, index)}
                            />
                        )}
                    </Col>
                </Fragment>
            ))}
        </Fragment>
    );
}
